<template>

  <div class="rectangle">
    <l-rectangle ref="element"
               :bounds="bounds"
               :fillColor="color"
               :color="color"
               :weight="weight"
               :bubblingMouseEvents="false"
               :options="{ editable: true }"
               @contextmenu="contextmenu($event)"
               @click="click($event)">
    </l-rectangle>
  </div>

</template>

<script>

import { LRectangle } from 'vue2-leaflet'
import { MapService } from '../../services/map.service.es6'

export default {
  name: 'map-rectangle',

  props: [ 'element', 'active' ],

  data () {
    return {
      editable: false,
      menu: [
        { title: this.$t('map.element.edit'), icon: 'pen', action: () => this.editable = true },
        { title: this.$t('map.element.remove'), icon: 'trash', action: () => MapService.removeElement(this.element) }
      ]
    }
  },

  computed: {
    color () {
      return this.active ? '#FF0000' : '#333333'
    },

    weight () {
      return this.active ? 3 : 1
    },

    bounds () {
      return [ this.element.locations.sw, this.element.locations.ne ]
    }
  },

  methods: {
    click(event) {
      this.$emit('click', event)
    },

    contextmenu (event) {
      this.$emit('menu', { event: event, data: this.menu })
    },
  },

  watch: {
    active (value) {
      if (this.editable && !value) {
        this.editable = false

        const bounds = this.$refs.element.mapObject._bounds
        this.$emit('save', { locations: { sw: bounds._southWest, ne: bounds._northEast } })
      }
    },

    editable (value) {
      const editor = this.$refs.element.mapObject.enableEdit()

      if (value)
        editor.enable()
      else
        editor.disable()
    }
  },

  components: {
    LRectangle
  }
}
</script>
